<script lang="ts">
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import { _ } from 'svelte-i18n';
    import { customerSettings } from '../../../stores/api';
    import SettingsRowNumber from './SettingsRowNumber.svelte';
    import { z } from 'zod';
    import SettingsRow from './SettingsRow.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';

    export let update: () => void;

    function validator(data: unknown) {
        return z.coerce.number().min(0).max(60).safeParse(data);
    }

    function _update() {
        $customerSettings.route_cost = {
            ...$customerSettings.route_cost,
        };
        update();
    }
</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('Route cost params')}</div>
    <div slot="content">
        <SettingsRowNumber
            annotation={$customerSettings.route_cost.unit}
            label={$_('Each route')}
            bind:value={$customerSettings.route_cost.per_init}
            update={_update}
            {validator}
        />
        <SettingsRowNumber
            annotation={$customerSettings.route_cost.unit}
            label={$_('Each item')}
            bind:value={$customerSettings.route_cost.per_item}
            update={_update}
            {validator}
        />
        <SettingsRowNumber
            annotation={$customerSettings.route_cost.unit}
            label={$_('Each minute')}
            bind:value={$customerSettings.route_cost.per_min}
            update={_update}
            {validator}
        />
        <SettingsRowNumber
            annotation={$customerSettings.route_cost.unit}
            label={$_('Each kilometer')}
            bind:value={$customerSettings.route_cost.per_km}
            update={_update}
            {validator}
        />
        <div style="padding: 3px 6px;">
            <SettingsRow>
                <SettingsRowLabel>
                    {$_('Include tolls')}
                </SettingsRowLabel>
                <SettingsRowValue>
                    <Checkbox
                        bind:checked={$customerSettings.route_cost.tolls}
                        label=""
                        onChange={s => {
                            _update();
                            return true;
                        }}
                    />
                </SettingsRowValue>
            </SettingsRow>
        </div>
    </div>
</TemplateSettingsGeneral>
